module.exports = __webpack_public_path__ + "static/media/walletSvg.1d7a7310.svg";